/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

export enum FacilityType {
    Standard = 'STANDARD',
    Itinerary = 'ITINERARY',
    ItinerarySingle = 'ITINERARY_SINGLE',
}

export enum LocationType {
    Campground = 'Campground',
    RecArea = 'Rec Area',
    Campsite = 'Campsite',
}

export enum TypeOfUse {
    Overnight = 'Overnight',
    Day = 'Day',
    Multi = 'Multi',
}

export enum Role {
    ROLE_PMO,
    ROLE_BAH_ADMIN,
    ROLE_CSR_SUPERVISOR,
    ROLE_CSR2,
    ROLE_FINANCE_USER,
    ROLE_FINANCE_ADMIN,
    ROLE_ATR,
    ROLE_FACILITY_MANAGER,
    ROLE_FACILITY_OPERATOR,
    ROLE_ATTENDANT,
    ROLE_HOST,
    ROLE_COOPERATOR,
    ROLE_SUPER_USER,
    ROLE_BAH_FINANCE,
    ROLE_PASS_OPERATOR,
}

export enum SeasonType {
    OffPeak = 'Off Peak',
    Peak = 'Peak',
    NonPeak = 'Non Peak',
    WalkIn = 'Walk In',
    Transistion = 'Transition',
}

export enum SeasonDisplay {
    Peak = 'Peak Season',
    OffPeak = 'Non-Peak Season',
    WalkIn = 'First-come, First-served Season',
    Transition = 'Transition',
    Lottery = 'Lottery',
}

export enum AttributeCategory {
    Amentities = 'Amentities',
    EquipmentDetails = 'Equipment Details',
    SiteDetails = 'Site Details',
}

export enum ScheduleType {
    StandardClosure = 'STANDARD_CLOSURE',
    HonoredClosure = 'HONORED_CLOSURE',
    ImmediateClosure = 'IMMEDIATE_CLOSURE',
    UndecidedClosure = 'UNDECIDED_CLOSURE', // called determined daily on the FE
    FCFS = 'FCFS',
    Open = 'OPEN',
    Management = 'MANAGEMENT',
    FlatNightRefund = 'FLAT_NIGHT_REFUND',
    FullNightRefund = 'FULL_NIGHT_REFUND',
}

export enum AvailabilityType {
    Open = 'Open',
    Available = 'Available',
    Closed = 'Closed',
    NotAvailable = 'Not Available',
    NotAvailableCutoff = 'Not Available Cutoff',
    NotReservable = 'Not Reservable',
    NotReservableManagement = 'Not Reservable Management',
    Lottery = 'Lottery',
    EarlyAccess = 'Early Access',
    NotYetReleased = 'NYR',
}

export enum RefundType {
    FullCost = 'fullCost',
    FlatRate = 'flatRate',
}

export enum ReservationStatus {
    HOLD = 'HOLD',
    HOLD_INDEFINITE = 'HOLD_INDEFINITE',
    RESERVED = 'RESERVED',
    PENDING_CHECKED_IN = 'PENDING_CHECKED_IN',
    CHECKED_IN = 'CHECKED_IN',
    PENDING_CHECKED_OUT = 'PENDING_CHECKED_OUT',
    CHECKED_OUT = 'CHECKED_OUT',
    PENDING_NOSHOW = 'PENDING_NOSHOW',
    NOSHOW = 'NOSHOW',
    MODIFIED = 'MODIFIED',
    ALTERED = 'ALTERED',
    PENDING_VOID = 'PENDING_VOID',
    VOID = 'VOID',
    PENDING_CANCELLATION = 'PENDING_CANCELLATION',
    CANCELLED = 'CANCELLED',
    PENDING_FULL_REFUND = 'PENDING_FULL_REFUND',
    FULL_REFUND = 'FULL_REFUND',
    PENDING_CLOSURE = 'PENDING_CLOSURE',
    CLOSED = 'CLOSED',
    PENDING_EARLY_DEPARTURE = 'PENDING_EARLY_DEPARTURE',
    EARLY_DEPARTURE = 'EARLY_DEPARTURE',
    PENDING_ALTERATION = 'PENDING_ALTERATION',
    PENDING_MODIFICATION = 'PENDING_MODIFICATION',
    REVERTED = 'REVERTED',
    PENDING_ACCOUNT_TRANSFER = 'PENDING_ACCOUNT_TRANSFER',
    ARCHIVED = 'ARCHIVED',
    UNDO_CHECK_IN = 'UNDO_CHECK_IN',
    TRANSFERRED = 'TRANSFERRED',
    PENDING_PAYMENT = 'PENDING_PAYMENT',
    PENDING_COMPLETION = 'PENDING_COMPLETION',
}

export enum ReservationFlag {
    BoatIncluded = 'boat_included',
}

export enum CampsiteReserveType {
    SiteSpecific = 'Site-Specific',
    NonSiteSpecific = 'Non Site-Specific',
    NonReservable = 'Overflow',
}

export enum OrderStatus {
    Pending = 'PENDING',
    Completed = 'COMPLETED',
}

export enum SalesChannel {
    Web = 'WEB',
    Field = 'FIELD',
}
